import { useEffect } from "react"
import TRACKING from "~/services/tracking"
import { FUNNELS } from "~/services/tracking/checkoutSession"

const FIELD_TAGS = ["INPUT", "SELECT", "TEXTAREA", "IFRAME"]

const fieldName = (element) => {
  if (!element || !FIELD_TAGS.includes(element.tagName)) return null
  return (
    element.name ||
    element.id ||
    element.getAttribute("aria-label") ||
    element.title ||
    element.tagName.toLowerCase()
  )
}

const funnelTracker = (funnel) =>
  funnel === FUNNELS.trafficLookup ? TRACKING.trafficLookup : TRACKING.paynycParking

const startSession = (funnel, fetcher) => {
  if (funnel === FUNNELS.trafficLookup) {
    TRACKING.trafficLookup.startCheckoutSession(fetcher)
    return
  }
  TRACKING.paynycParking.startCheckoutSession(true)
}

// Mount only on the checkout of the given funnel; `fetcher` is required for
// traffic_lookup.
const CheckoutAbandonTracker = ({ funnel = FUNNELS.payNyc, fetcher }) => {
  useEffect(() => {
    const tracker = funnelTracker(funnel)
    const onFocusIn = (event) => tracker.checkoutFieldFocused(fieldName(event.target))
    // Focus moving into a hosted payment-field iframe only blurs the window.
    const onWindowBlur = () => tracker.checkoutFieldFocused(fieldName(document.activeElement))
    const onPageHide = () => tracker.endCheckoutSession({ beacon: true })

    startSession(funnel, fetcher)
    document.addEventListener("focusin", onFocusIn)
    window.addEventListener("blur", onWindowBlur)
    window.addEventListener("pagehide", onPageHide)
    return () => {
      document.removeEventListener("focusin", onFocusIn)
      window.removeEventListener("blur", onWindowBlur)
      window.removeEventListener("pagehide", onPageHide)
      tracker.endCheckoutSession()
    }
  }, [funnel, fetcher])
  return null
}

export default CheckoutAbandonTracker
